// extracted by mini-css-extract-plugin
export default {"container":"fileAutofill_container__OKFq+","spinner":"fileAutofill_spinner__qJ367","spin":"fileAutofill_spin__h62Op"};